import styled, { css } from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";

/**
 * 클릭 가능한 약품명 래퍼.
 * - $clickable=true: 포인터 커서 + 호버 시 밑줄(허가사항 슬라이드 진입 힌트)
 * - $visited=true: 이번 세션에 허가사항을 열어본 약 → 회색(글자·밑줄 모두 currentColor 상속)
 * 자식 Text는 color 미지정(inherit)이라 글자색이 이 span 색을 따르므로 밑줄과 일치한다.
 */
export const DrugNameLink = styled.span<{ $clickable?: boolean; $visited?: boolean }>`
  display: inline-flex;
  align-items: center;
  color: ${({ $visited }) =>
    $visited ? COLOR_SYSTEM.get("Gray")?.[400] : COLOR_SYSTEM.get("Gray")?.[800]};
  ${({ $clickable }) =>
    $clickable &&
    css`
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    `}
`;
